import { NavLink } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import { moduleBinary } from "../../common/authority";

const MenuItems = ({ items, moduleCatBinary }) => {

  const [dropdown, setDropdown] = useState(false);
  const liRef = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && liRef.current && !liRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const closeDropdown = () => {
    dropdown && setDropdown(false);
  };

  let submenuList = [];
  if (items.id !== undefined) {
    items.submenu.map((submenu, index) => {
      if(moduleCatBinary[items.id] & moduleBinary[index]) {     
        // console.log(index, items.id, moduleCatBinary[items.id])
        // console.log(index, submenu, moduleBinary[index])
        submenuList.push(submenu);
      }
    })
  }

  return (
    <li className="menu-items" ref={liRef} onClick={closeDropdown}>
      {items.submenu !== undefined && Object.keys(items.submenu).length > 0 ? (
          <>
            <button
              type="button"
              aria-haspopup="menu"
              aria-expanded={dropdown ? "true" : "false"}
              onClick={() => setDropdown((prev) => !prev)}
            >
              {items.title}
              {/* <NavLink to={items.key}>{items.title}</NavLink> */}
            </button>
            {items.id !== undefined
              ? <>
                  {items.submenu.map((submenu, index) => 
                    moduleCatBinary[items.id] & moduleBinary[index]        
                    ? <Dropdown submenus={submenuList} key={index} dropdown={dropdown} />       
                    : <></> 
                  )}
                  </>
              : <></>
            }
          </>
      ) : (
        <NavLink to={items.key}>{items.title}</NavLink>
      )}
    </li>
    // <li className="menu-items" ref={liRef} onClick={closeDropdown}>
    //   {items.submenu /*&& items.key*/ ? (
    //     <>
    //       <button
    //         type="button"
    //         aria-haspopup="menu"
    //         aria-expanded={dropdown ? "true" : "false"}
    //         onClick={() => setDropdown((prev) => !prev)}
    //       >
    //         {/* <NavLink to={items.key}>{items.title}</NavLink> */}
    //         {items.title}
    //       </button>
    //       {items.id !== undefined
    //         ? 
    //           <>
    //             {items.submenu.map((submenu, index) => 
    //               moduleCatBinary[items.id] & moduleBinary[index]        
    //               ? <Dropdown submenus={submenuList} key={index} dropdown={dropdown} />       
    //               : <></> 
    //             )}
    //           </>
    //         : <></>
    //       }

    //       {/* <Dropdown submenus={items.submenu} dropdown={dropdown} moduleCatBinary={moduleCatBinary}/> */}
    //     </>
    //   ) : !items.key && items.submenu ? (
    //     <>
    //       {/* <button>{items.title} </button> */}
    //       {items.title}
    //     </>
    //   ) : (
    //     !items.submenu && (
    //       <NavLink to={items.key}>{items.title}</NavLink>
    //     )      
    //   )}
    // </li>
  );
};

export default MenuItems;
